import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-loader-metrics',
  standalone: true,
  templateUrl: './loader-metrics.component.html',
  styleUrls: ['./loader-metrics.component.scss']
})
export class LoaderMetricsComponent implements OnInit {

   BASE_IMG_URL: string = environment.BASE_IMG_URL;

  constructor() { }

  ngOnInit() {
  }

}
